import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/show/store/deal/actions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { put } from 'helpers/api';

import StatusLabel from 'components/status_label';
import Card from 'bundles/apex/card';

import './styles.scss';

export const ListingHeader = ({ changeDeal, dealPath, isParentDeal, listing, project }) => {
  const source = isParentDeal ? project : listing;
  const handleDisconnect = async () => {
    const updatedDeal = await put(dealPath, { listingId: null });
    if (updatedDeal) return changeDeal(updatedDeal);
  };

  return (
    <Card className="listing-header" fullWidth>
      <div className="flex-grow-1">
        This deal is connected to Buildout Marketing.&nbsp;
        {!isParentDeal && (
          <span name="listing-status">
            The listing status is&nbsp;
            <b><StatusLabel.LabelAsSpan status={source.status} /></b>.
          </span>
        )}
      </div>
      {listing.userCanViewProject && (
        <div>
          <a className="view-listing" href={source.path} name="view">
            <FontAwesomeIcon className="mr-2" icon={faEye} />
            <span className="mr-4" name="view-label">View {isParentDeal ? 'Property' : 'Listing'}</span>
          </a>
          {!isParentDeal && (
            <span
              className="text-danger clickable one-line"
              name="disconnect"
              onClick={handleDisconnect}
            >
              <FontAwesomeIcon className="mr-2" icon={faTimes} />
              <span>Disconnect</span>
            </span>
          )}
        </div>
      )}
    </Card>
  );
};

ListingHeader.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  dealPath: PropTypes.string.isRequired,
  isParentDeal: PropTypes.bool,
  listing: PropTypes.shape({
    path: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }),
  project: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = ({ deal }) => ({
  dealPath: deal.path,
  isParentDeal: deal.parent,
  listing: deal.listing,
  project: deal.project
});

const mapDispatchToProps = { changeDeal };

export default connect(mapStateToProps, mapDispatchToProps)(ListingHeader);
